export function initStudio() {
  const container = document.getElementById("studio-page");
  if (!container) return;

  // Tab switching is now handled server-side via Turbo Frame
  // No client-side tab switching needed
}
